




import { Component, Vue } from 'vue-property-decorator';
import { INotificationsSystemic } from './types';

@Component
export default class NotificationsSystemic
  extends Vue
  implements INotificationsSystemic {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/notification/views/systemic/NotificationsSystemic.vue